import { api } from '@/lib/api';

export interface Persona {
  id: string;
  slug: string;
  nocodb_id: number | null;
  title: string;
  name: string | null;
  photo_url: string | null;
  buying_role: string | null;
  details: Record<string, unknown>;
  archetype: string | null;
  tier: string | null;
  icp: string | null;
  age: string | null;
  budget_authority: string | null;
  decision_timeline: string | null;
  pain_points: string[];
  quote: string | null;
  decision_triggers: string[];
  objections: string[];
  position: number;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export async function listPersonas(): Promise<Persona[]> {
  const res = await api.get<{ personas: Persona[] }>('/v4/personas');
  return res.personas;
}

export async function getPersona(idOrSlug: string): Promise<Persona> {
  return api.get<Persona>(`/v4/personas/${encodeURIComponent(idOrSlug)}`);
}
